import * as Yup from 'yup';

const requiredString = Yup.string()
  .trim()
  .required('payment.form.validation.required');

export const couponSchema = Yup.object({
  coupon: requiredString,
});
